import React from 'react';
import '../chat-css/ConversationSkeleton.css';

/*
 * The shape of a conversation, while the real one is being fetched.
 *
 * Switching chat used to blank the whole panel and put a spinner in the middle
 * of it: the header, the messages and the field all went at once, and came back
 * at once a moment later, which is the jolt operators feel every time they move
 * between two chats.
 *
 * Nothing here is the visitor's. The store still holds the chat being left
 * until the new one arrives, so anything with a name in it would show the wrong
 * person - these are grey shapes in the places the real ones will take.
 */
/*
 * Enough of them to reach the top of any panel, and sized unevenly - a column
 * of identical blocks reads as a loading bar lying on its side, not as a
 * conversation. They are laid out from the bottom, where the newest messages
 * are, and whatever does not fit runs off the top under the fade.
 */
const BUBBLES = [
    {side: 'in', width: '42%', height: 38},
    {side: 'out', width: '30%', height: 30},
    {side: 'in', width: '54%', height: 52},
    {side: 'out', width: '36%', height: 38},
    {side: 'in', width: '26%', height: 30},
    {side: 'out', width: '46%', height: 44},
    {side: 'in', width: '38%', height: 38},
    {side: 'out', width: '23%', height: 30},
    {side: 'in', width: '50%', height: 52},
    {side: 'out', width: '33%', height: 38},
];

const ConversationSkeleton = () => (
    <div className="conversation-skeleton" aria-hidden="true">
        <div className="conversation-skeleton__header">
            <span className="conversation-skeleton__avatar skeleton-shape"/>
            <div className="conversation-skeleton__lines">
                <span className="conversation-skeleton__line skeleton-shape" style={{width: '140px'}}/>
                <span className="conversation-skeleton__line skeleton-shape" style={{width: '90px'}}/>
            </div>
        </div>

        <div className="conversation-skeleton__messages">
            {BUBBLES.map((bubble, index) => (
                <span
                    key={index}
                    className={'conversation-skeleton__bubble skeleton-shape conversation-skeleton__bubble--' + bubble.side}
                    style={{width: bubble.width, height: bubble.height + 'px'}}
                />
            ))}
        </div>

        <div className="conversation-skeleton__composer skeleton-shape"/>
    </div>
);

export default ConversationSkeleton;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/ConversationSkeleton.jsx